import { createStructuredSelector } from 'reselect';
import { selectAccountID, selectCsrBusinessFunction } from '../../../../selectors/globalSelectors';

export const getGrantsActivityStates = (data) => data.grantsActivity;

export const getRecurringGrantsData = (data) => {
    const { recurringExchanges } = getGrantsActivityStates(data);
    return recurringExchanges.data
}

export const getRecurringGrantLoadingStatus = (data) => {
    const { recurringExchanges } = getGrantsActivityStates(data);
    return recurringExchanges.isLoadingRecurring;
  };

  export const lazyLoadRecurringGrants = (data) => {
    const { recurringExchanges } = getGrantsActivityStates(data);
    return recurringExchanges.lazy
}

export const getSingleGrantsData = (data) => {
    const { singleExchanges } = getGrantsActivityStates(data);
    return singleExchanges.data
}

export const getSingleGrantLoadingStatus = (data) => {
    const { singleExchanges } = getGrantsActivityStates(data);
    return singleExchanges.isLoadingGrants;
  };

export const getGrantAgreementData = (data) => {
    const { grantAgreement } = getGrantsActivityStates(data);
    return grantAgreement.data
}

export const cancelGrantsActivity = (data) => {
    const { cancel } = getGrantsActivityStates(data);
    return cancel
}

export const cancelGrantsActivityResponse = (data) => {
    const { cancelResponse } = getGrantsActivityStates(data);
    return cancelResponse
}

export const lazyLoadSingleGrants = (data) => {
    const { singleExchanges } = getGrantsActivityStates(data);
    return singleExchanges.lazy
}

export const singleGrantsDataAvail = (data) => {
    const { singleExchanges } = getGrantsActivityStates(data);
    return singleExchanges.avail
}

export const sgShowLoader = (data) => {
    const { singleExchanges } = getGrantsActivityStates(data);
    return singleExchanges.showGaLoader
} 

export const getTabsSelection = (data) => {
    const { tab } = getGrantsActivityStates(data);
    return tab
}

export const getStartDate = (data) => {
    const { dates } = getGrantsActivityStates(data);
    return dates.start
}

export const getEndDate = (data) => {
    const { dates } = getGrantsActivityStates(data);
    return dates.end
}

export const getFilteredData = (data) => {
    const { filtered } = getGrantsActivityStates(data);
    return filtered
}


export const grantActivityDerivedStates = createStructuredSelector({
    recurringGrants: getRecurringGrantsData,
    singleGrants: getSingleGrantsData,
    isLoadingSingleGrants: getSingleGrantLoadingStatus,
    isLoadingRecurringGrants: getRecurringGrantLoadingStatus,
    agreements: getGrantAgreementData,
    cancel: cancelGrantsActivity,
    cancelData: cancelGrantsActivityResponse,
    loadedLazyGrants: lazyLoadSingleGrants,
    avail: singleGrantsDataAvail,
    tabs: getTabsSelection,
    startDate: getStartDate,
    endDate: getEndDate,
    accountID: selectAccountID,
});

export const ActivityTimeFrameDerivedState = createStructuredSelector({
    startDate: getStartDate,
    endDate: getEndDate,
})

export const ContentComponentDerivedStates = createStructuredSelector({
    recurringData: getRecurringGrantsData,
    singleData: getSingleGrantsData,
    agreementsData: getGrantAgreementData,
    lazyLoaded: lazyLoadSingleGrants,
    lazyLodedRec: lazyLoadRecurringGrants,
    tabs: getTabsSelection,
    csrBusinessFunction: selectCsrBusinessFunction,
    avail: singleGrantsDataAvail
});

export const ContentPrinterDerivedStates = createStructuredSelector({
    agreement: getGrantAgreementData,
    printData: getFilteredData
});

export const TabContentDerivedStates = createStructuredSelector({
    singleData: getSingleGrantsData,
    recurringData: getRecurringGrantsData,
    avail: singleGrantsDataAvail,
    sgShowLoader: sgShowLoader,
    lazyLoaded: lazyLoadSingleGrants,
    lazyLodedRec: lazyLoadRecurringGrants
});